import * as Yup from "yup";

export const ValidationPin = Yup.object().shape({
  secret_pin: Yup.string().min(6).required(),
});
